<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page employee-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- EMPLOYEE HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">
        <div class="bbm-main-info">
          <div class="bbm-avatar employee-profile-avatar">
            <img
              src="/assets/emploees.png"
              [alt]="'Employee' | transloco"
            >
          </div>

          <div class="bbm-copy bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'employee profile' | transloco }}
            </span>

            <h2>{{ name || '-' }}</h2>

            <p>
              {{ 'job title' | transloco }}:
              {{ job_title || '-' }}
            </p>
          </div>
        </div>

        <button
          type="button"
          class="bbm-hero-icon noPrint"
          aria-label="Print"
          onclick="window.print();"
        >
          <i class="fa-solid fa-print"></i>
        </button>
      </div>

      <div class="bbm-details-grid bbm-hero-details">
        <div class="bbm-detail-chip">
          <i class="fa-solid fa-wallet"></i>

          <span>{{ 'salary' | transloco }}</span>

          <strong class="bbm-money-value">
            {{ salary || 0 }}
          </strong>
        </div>

        <div class="bbm-detail-chip">
          <i class="fa-solid fa-calendar-days"></i>

          <span>{{ 'Salary Month' | transloco }}</span>

          <strong>
            {{ salaryMonth || '-' }}
          </strong>
        </div>
      </div>

      <div class="bbm-actions-grid bbm-hero-actions noPrint">
        <button
          type="button"
          class="bbm-action-btn bbm-action-success bbm-action-wide"
          (click)="paySalary()"
        >
          <i class="fa-solid fa-money-bill-wave"></i>

          <span>
            {{ 'pay salary this month' | transloco }}
            {{ salaryMonth }}
          </span>
        </button>
      </div>

    </section>

    <!-- SALARY SUMMARY -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <div class="bbm-detail-chip bbm-detail-primary">
        <i class="fa-solid fa-money-check-dollar"></i>

        <span>{{ 'Base Salary' | transloco }}</span>

        <strong class="bbm-money-value">
          {{ salary || 0 }}
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-gift"></i>

        <span>{{ 'Bonuses' | transloco }}</span>

        <strong>
          {{ totalBonuses }}
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-danger">
        <i class="fa-solid fa-arrow-trend-down"></i>

        <span>{{ 'Loans' | transloco }}</span>

        <strong>
          {{ totalLoans }}
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-dark">
        <i class="fa-solid fa-percent"></i>

        <span>{{ 'Deductions' | transloco }}</span>

        <strong>
          {{ totalDeductions }}
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-success bbm-detail-wide">
        <i class="fa-solid fa-scale-balanced"></i>

        <span>{{ 'Net Salary' | transloco }}</span>

        <strong>
          {{ netSalary }}
        </strong>
      </div>

    </section>

    <!-- FILTERS -->
    <section class="bbm-form-ticket noPrint">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'filters' | transloco }}
          </span>

          <h3>
            {{ 'Filter transactions' | transloco }}
          </h3>
        </div>

        <button
          type="button"
          class="bbm-action-btn bbm-action-warning bbm-action-compact"
          (click)="clearFilters()"
        >
          <i class="fa-solid fa-filter-circle-xmark"></i>

          <span>{{ 'clear' | transloco }}</span>
        </button>
      </div>

      <div class="bbm-form-grid">

        <div class="bbm-field">
          <label for="employee-filter-date">
            {{ 'Filter by day' | transloco }}
          </label>

          <select
            id="employee-filter-date"
            class="bbm-control mobile-input"
            [(ngModel)]="filteredDate"
            (change)="filterByDate()"
          >
            <option value="">
              {{ 'Select Day' | transloco }}
            </option>

            <option
              *ngFor="let date of uniqueDates"
              [value]="date"
            >
              {{ date }}
            </option>
          </select>
        </div>

        <div class="bbm-field">
          <label for="employee-filter-month">
            {{ 'Filter by Month' | transloco }}
          </label>

          <select
            id="employee-filter-month"
            class="bbm-control mobile-input"
            [(ngModel)]="filteredMonth"
            (change)="filterByMonth()"
          >
            <option value="">
              {{ 'Select Month' | transloco }}
            </option>

            <option
              *ngFor="let month of uniqueMonths"
              [value]="month"
            >
              {{ month }}
            </option>
          </select>
        </div>

      </div>

    </section>

    <!-- QUICK ACTIONS -->
    <section class="bbm-actions-grid bbm-actions-three bbm-section noPrint">

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="addLoan()"
      >
        <i class="fa-solid fa-minus"></i>
        <span>{{ 'Add loan' | transloco }}</span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="addBonuses()"
      >
        <i class="fa-solid fa-plus"></i>
        <span>{{ 'Add Bonuse' | transloco }}</span>
      </button>

      <button
        type="button"
        class="bbm-action-btn employee-action-dark"
        (click)="addDeduction()"
      >
        <i class="fa-solid fa-percent"></i>
        <span>{{ 'Add deduction' | transloco }}</span>
      </button>

    </section>

    <!-- LOANS -->
    <section class="bbm-form-ticket employee-records-section">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Loans' | transloco }}
          </span>

          <h3>{{ 'Loans' | transloco }}</h3>

          <p>
            {{ loans.length }}
            {{ 'records' | transloco }}
          </p>
        </div>

        <span class="bbm-value-pill bbm-value-danger">
          {{ totalLoans }}
        </span>
      </div>

      <div
        class="bbm-ticket-list"
        *ngIf="visibleLoans.length > 0; else noLoans"
      >
        <article
          class="bbm-ticket bbm-ticket-danger"
          *ngFor="let loan of visibleLoans"
        >
          <div class="bbm-ticket-top">
            <div class="bbm-main-info">

              <div class="bbm-avatar employee-record-avatar">
                <i class="fa-solid fa-arrow-down"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ formatRecordDate(loan.created_at) }}
                </span>

                <h3 class="bbm-money-value">
                  {{ loan.amount }}
                </h3>

                <p>
                  <i class="fa-solid fa-calendar-day"></i>
                  <span>
                    {{ formatRecordDate(loan.created_at) }}
                  </span>
                </p>
              </div>

            </div>
          </div>

          <div class="bbm-details-grid">
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-file-lines"></i>

              <span>{{ 'note' | transloco }}</span>

              <strong>
                {{ loan.note || '-' }}
              </strong>
            </div>
          </div>
        </article>
      </div>

      <ng-template #noLoans>
        <div class="bbm-empty-state">
          <i class="fa-solid fa-hand-holding-dollar"></i>

          <h4>
            {{ 'No loans found' | transloco }}
          </h4>
        </div>
      </ng-template>

    </section>

    <!-- BONUSES -->
    <section class="bbm-form-ticket employee-records-section">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Bonuses' | transloco }}
          </span>

          <h3>{{ 'Bonuses' | transloco }}</h3>

          <p>
            {{ bonuses.length }}
            {{ 'records' | transloco }}
          </p>
        </div>

        <span class="bbm-value-pill bbm-value-success">
          {{ totalBonuses }}
        </span>
      </div>

      <div
        class="bbm-ticket-list"
        *ngIf="visibleBonuses.length > 0; else noBonuses"
      >
        <article
          class="bbm-ticket bbm-ticket-success"
          *ngFor="let bonuse of visibleBonuses"
        >
          <div class="bbm-ticket-top">
            <div class="bbm-main-info">

              <div class="bbm-avatar employee-record-avatar">
                <i class="fa-solid fa-arrow-up"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ formatRecordDate(bonuse.created_at) }}
                </span>

                <h3 class="bbm-money-value">
                  {{ bonuse.amount }}
                </h3>

                <p>
                  <i class="fa-solid fa-calendar-day"></i>
                  <span>
                    {{ formatRecordDate(bonuse.created_at) }}
                  </span>
                </p>
              </div>

            </div>
          </div>

          <div class="bbm-details-grid">
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-file-lines"></i>

              <span>{{ 'note' | transloco }}</span>

              <strong>
                {{ bonuse.note || '-' }}
              </strong>
            </div>
          </div>
        </article>
      </div>

      <ng-template #noBonuses>
        <div class="bbm-empty-state">
          <i class="fa-solid fa-gift"></i>

          <h4>
            {{ 'No bonuses found' | transloco }}
          </h4>
        </div>
      </ng-template>

    </section>

    <!-- DEDUCTIONS -->
    <section class="bbm-form-ticket employee-records-section">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Deductions' | transloco }}
          </span>

          <h3>{{ 'Deductions' | transloco }}</h3>

          <p>
            {{ deductions.length }}
            {{ 'records' | transloco }}
          </p>
        </div>

        <span class="bbm-value-pill bbm-value-dark">
          {{ totalDeductions }}
        </span>
      </div>

      <div
        class="bbm-ticket-list"
        *ngIf="visibleDeductions.length > 0; else noDeductions"
      >
        <article
          class="bbm-ticket employee-ticket-dark"
          *ngFor="let deduction of visibleDeductions"
        >
          <div class="bbm-ticket-top">
            <div class="bbm-main-info">

              <div
                class="bbm-avatar employee-record-avatar employee-record-avatar-dark"
              >
                <i class="fa-solid fa-scissors"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ formatRecordDate(deduction.created_at) }}
                </span>

                <h3 class="bbm-money-value">
                  {{ deduction.amount }}
                </h3>

                <p>
                  <i class="fa-solid fa-calendar-day"></i>
                  <span>
                    {{ formatRecordDate(deduction.created_at) }}
                  </span>
                </p>
              </div>

            </div>
          </div>

          <div class="bbm-details-grid">
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-file-lines"></i>

              <span>{{ 'note' | transloco }}</span>

              <strong>
                {{ deduction.note || '-' }}
              </strong>
            </div>
          </div>
        </article>
      </div>

      <ng-template #noDeductions>
        <div class="bbm-empty-state">
          <i class="fa-solid fa-receipt"></i>

          <h4>
            {{ 'No deductions found' | transloco }}
          </h4>
        </div>
      </ng-template>

    </section>

    <!-- LOAD MORE -->
    <div
      class="bbm-loader noPrint"
      *ngIf="hasMoreData"
    >
      <span
        class="bbm-loader-spinner"
        *ngIf="isLoadingMore"
        aria-hidden="true"
      ></span>

      <span *ngIf="!isLoadingMore">
        {{ 'Scroll to load more' | transloco }}
      </span>
    </div>

  </div>
</div>

<!-- FINANCIAL TRANSACTION MODAL -->
<div
  *ngIf="showFinPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
  (click)="close()"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="popupTitle"
    (click)="$event.stopPropagation()"
  >
    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ 'financial transaction' | transloco }}
        </span>

        <h4>{{ popupTitle }}</h4>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        aria-label="Close"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">

      <div class="bbm-modal-row">
        <label for="employee-financial-amount">
          {{ 'amount' | transloco }}
        </label>

        <input
          id="employee-financial-amount"
          class="bbm-control mobile-input"
          type="text"
          inputmode="decimal"
          [(ngModel)]="amount"
          (input)="onAmountInput($event)"
          placeholder="{{ 'amount' | transloco }}"
        >
      </div>

      <div class="bbm-modal-row">
        <label for="employee-financial-note">
          {{ 'note' | transloco }}
        </label>

        <textarea
          id="employee-financial-note"
          class="bbm-control bbm-textarea mobile-input textarea"
          [(ngModel)]="note"
          placeholder="{{ 'note' | transloco }}"
        ></textarea>
      </div>

    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="onSubmit()"
      >
        <i class="fa-solid fa-check"></i>
        <span>{{ 'Submit' | transloco }}</span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
        <span>{{ 'close' | transloco }}</span>
      </button>
    </div>

  </section>
</div>